const route = {
  'ROOT': '/',
  'SPLIT_LINKS': '/split-links',
  'SPLIT_LINKS_CREATE': '/split-links/create',
  'SPLIT_LINKS_EDIT': '/split-links/edit',
  'REFER': '/refer',
  'AFFILIATE_NETWORK': '/affiliate-network',
  'MERCHANTS': '/merchants',
  'MERCHANTS_ADD': '/merchants/add',
  'MERCHANTS_EDIT': '/merchants/edit',
  'DOMAINS': '/domains',
  'DOMAIN_ADD': '/domains/add',
  'DOMAIN_EDIT': '/domains/edit',
  'COMMISSIONS': '/commissions',
  'COMMISSIONS_DETAILS': '/commissions/details',
  'COMMISSIONS_EDIT': '/commissions/edit',
  'INVOICES': '/invoices',
  'INVOICES_SUMMARY': '/invoices/summary',
  'ANALYTICS_SPLIT_LINKS': '/analytics/split-links',
  'ANALYTICS_SPLIT_LINK_EDIT': '/analytics/split-links/edit',
  'ANALYTICS_USERS': '/analytics/users',
  'ANALYTICS_CAMPAIGNS': '/analytics/campaigns',
  'ANALYTICS_MERCHANTS': '/analytics/merchants',
  'DISCOVER': '/discover',
  'DISCOVER_USER_EDIT': '/discover/edit-user',
  'DATA_EXPORTS': '/data-exports',
  'PAYMENT_METHODS': '/payment-methods',
  'PAYMENT_METHOD_ADD': '/payment-methods/add',
  'MEMBERS_LIST': '/members/list',
  'MEMBERS_INVITATIONS': '/members/invitations',
  'MEMBERS_INVITE': '/members/invite',
  'MEMBERS_EDIT': '/members/edit',
  'ORGANIZATION': '/organization',
  'ORGANIZATION_EDIT_CONTACT': '/organization/edit/contact',
  'ACCOUNT': '/account',
  'ACCOUNT_NAME_EDIT': '/account/name-edit',
  'ACCOUNT_EMAIL_EDIT': '/account/email-edit',
  'ACCOUNT_PHONE_EDIT': '/account/phone-edit',
  'ACCOUNT_PHONE_VERIFICATION': '/account/phone-verification',
  'TOOLS': '/tools',
  'HELP': '/help',
  'NOTIFICATIONS': '/notifications',
  'NOTIFICATIONS_SETTINGS': '/notifications/settings',
  'UNMASKING_CONNECTIONS': '/connections',
  'CHAT': '/chat',
  'PROMOTIONS_LIST': '/promotions',
  'PROMOTIONS_CREATE': '/promotions/create',
  'PROMOTIONS_EDIT': '/promotions/edit',
  'MY_CREATORS_LIST': '/my-creators',

  'BONUSES': '/bonuses',
  'BONUS_CREATE': '/bonuses/create',
  'BONUS_EDIT': '/bonuses/edit',

  'GROUPS': '/groups',
  'GROUPS_ADD': '/groups/add',
  'GROUPS_EDIT': '/groups/edit',

  'CREATOR': '/creator',
  'BILLING': '/billing',
  'PERFORMANCE': '/performance',

  'CODES_CREATE': '/codes/create',
  'CODES_EDIT': '/codes/edit',

  'GIFTS_LIST': '/gifts',
  'GIFTS_CREATE': '/gifts/create',
  'GIFTS_EDIT': '/gifts/edit',

  'LOOKBOOK_CREATE': '/lookbook/create',
  'LOOKBOOK_EDIT': '/lookbook/edit',
  'LOOKBOOK_INVENTORY': '/lookbook/inventory',
  'LOOKBOOK_PREVIEW': '/lookbook/preview',
  'LOOKBOOK_SUMMARY': '/lookbook/summary',

  'REIMBURSEMENT_CREATE': '/reimbursement/create',
  'REIMBURSEMENT_EDIT': '/reimbursement/edit',

  'DISCOUNTS_LIST': '/discounts',
  'DISCOUNTS_CREATE': '/discounts/create',
  'DISCOUNTS_EDIT': '/discounts/edit'
};

export const routesNames = {
  [`${route['ROOT']}`]: 'Home',
  [`${route['SPLIT_LINKS']}`]: 'SplitLinks',
  [`${route['SPLIT_LINKS_CREATE']}`]: 'Create a new SplitLink',
  [`${route['SPLIT_LINKS_EDIT']}`]: 'Edit SplitLink',
  [`${route['REFER']}`]: 'Invite',
  [`${route['AFFILIATE_NETWORK']}`]: 'Affiliate Network',
  [`${route['MERCHANTS']}`]: 'Merchants',
  [`${route['MERCHANTS_ADD']}`]: 'Add a new merchant',
  [`${route['MERCHANTS_EDIT']}`]: 'Edit merchant',
  [`${route['DOMAINS']}`]: 'Domains',
  [`${route['DOMAIN_ADD']}`]: 'Add a new Domain',
  [`${route['DOMAIN_EDIT']}`]: 'Edit Domain',
  [`${route['COMMISSIONS']}`]: 'Commissions',
  [`${route['COMMISSIONS_DETAILS']}`]: 'Commission Details',
  [`${route['COMMISSIONS_EDIT']}`]: 'Edit Commission',
  [`${route['UNMASKING_CONNECTIONS']}`]: 'Connections',
  [`${route['INVOICES']}`]: 'Invoices',
  [`${route['INVOICES_SUMMARY']}`]: 'Invoices Summary',
  [`${route['ANALYTICS_SPLIT_LINKS']}`]: 'Analytics - By Link',
  [`${route['ANALYTICS_SPLIT_LINK_EDIT']}`]: 'Analytics - Edit SplitLink',
  [`${route['ANALYTICS_USERS']}`]: 'Analytics - By User',
  [`${route['ANALYTICS_CAMPAIGNS']}`]: 'Analytics - By Campaign',
  [`${route['ANALYTICS_MERCHANTS']}`]: 'Analytics - Merchants',
  [`${route['DISCOVER']}`]: 'Discover',
  [`${route['DISCOVER_USER_EDIT']}`]: 'Edit user tags',
  [`${route['DATA_EXPORTS']}`]: 'Data Exports',
  [`${route['PAYMENT_METHOD_ADD']}`]: 'Add Payment Method',
  [`${route['PAYMENT_METHODS']}`]: 'Payment Methods',
  [`${route['MEMBERS_LIST']}`]: 'Team Members',
  [`${route['MEMBERS_INVITATIONS']}`]: 'Invitations',
  [`${route['MEMBERS_INVITE']}`]: 'Invite a new Member',
  [`${route['MEMBERS_EDIT']}`]: 'Edit Member',
  [`${route['ORGANIZATION']}`]: 'Organization Details',
  [`${route['ORGANIZATION_EDIT_CONTACT']}`]: 'Organization Details',
  [`${route['ACCOUNT']}`]: 'Account Info',
  [`${route['ACCOUNT_NAME_EDIT']}`]: 'Full name (optional)',
  [`${route['ACCOUNT_EMAIL_EDIT']}`]: 'Change email',
  [`${route['ACCOUNT_PHONE_EDIT']}`]: 'Change phone number',
  [`${route['ACCOUNT_PHONE_VERIFICATION']}`]: 'Enter a verification code',
  [`${route['TOOLS']}`]: 'Tools',
  [`${route['HELP']}`]: 'Help',
  [`${route['NOTIFICATIONS']}`]: 'Notifications and activities',
  [`${route['NOTIFICATIONS_SETTINGS']}`]: 'Notifications settings',
  [`${route['CHAT']}`]: 'Chat',
  [`${route['PROMOTIONS_LIST']}`]: 'Promotions',
  [`${route['PROMOTIONS_CREATE']}`]: 'Create Promotion',
  [`${route['PROMOTIONS_EDIT']}`]: 'Edit Promotion',
  [`${route['MY_CREATORS_LIST']}`]: 'My Creators',

  [`${route['BONUSES']}`]: 'Bonuses',
  [`${route['BONUS_CREATE']}`]: 'Create bonus',
  [`${route['BONUS_EDIT']}`]: 'Edit bonus',

  [`${route['GROUPS']}`]: 'Groups',
  [`${route['GROUPS_ADD']}`]: 'Add Group',
  [`${route['GROUPS_EDIT']}`]: 'Edit Group',

  [`${route['CREATOR']}`]: 'Creator',
  [`${route['BILLING']}`]: 'Billing & balance',
  [`${route['PERFORMANCE']}`]: 'Performance',

  [`${route['CODES_CREATE']}`]: 'Create discount',
  [`${route['CODES_EDIT']}`]: 'Edit discount',

  [`${route['GIFTS_LIST']}`]: 'Gifts',
  [`${route['GIFTS_CREATE']}`]: 'Create discount',
  [`${route['GIFTS_EDIT']}`]: 'Edit discount',

  [`${route['LOOKBOOK_CREATE']}`]: 'Lookbook Builder',
  [`${route['LOOKBOOK_EDIT']}`]: 'Lookbook Builder',
  [`${route['LOOKBOOK_INVENTORY']}`]: 'Lookbook Inventory',
  [`${route['LOOKBOOK_PREVIEW']}`]: 'Lookbook Preview',
  [`${route['LOOKBOOK_SUMMARY']}`]: 'Lookbook Summary',

  [`${route['REIMBURSEMENT_CREATE']}`]: 'Shopping Reimbursement',
  [`${route['REIMBURSEMENT_EDIT']}`]: 'Edit Shopping Reimbursement',

  [`${route['DISCOUNTS_LIST']}`]: 'Discounts',
  [`${route['DISCOUNTS_CREATE']}`]: 'Create discount',
  [`${route['DISCOUNTS_EDIT']}`]: 'Edit discount'
};

export const normalizePath = (path = '/') => {
  // strip query and hash
  let p = path.split(/[?#]/)[0] || '/';

  // ensure leading slash
  if (!p.startsWith('/')) {
    p = '/' + p;
  }

  // remove trailing slash(es) except for root
  if (p.length > 1) {
    p = p.replace(/\/+$/, '');
  }

  return p;
};

export const getRouteName = pathname => {
  const path = normalizePath(pathname);

  // 1. exact match
  if (routesNames[path]) {
    return routesNames[path];
  }

  // 2. longest prefix match on segment boundaries
  let bestMatchKey = null;

  Object.keys(routesNames).forEach(routePath => {
    const base = normalizePath(routePath);

    if (base === '/') {
      // only match root exactly
      if (path === '/') {
        bestMatchKey = base;
      }
      return;
    }

    const isExact = path === base;
    const isChild = path.startsWith(base + '/'); // segment boundary

    if ((isExact || isChild)) {
      if (!bestMatchKey || base.length > bestMatchKey.length) {
        bestMatchKey = base;
      }
    }
  });

  return bestMatchKey ? routesNames[bestMatchKey] : undefined;
};
